/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wizard_Step_SavedInputs */

const en_wizard_step_saved = /** @type {(inputs: Wizard_Step_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs saved`)
};

const id_wizard_step_saved = /** @type {(inputs: Wizard_Step_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen tersimpan`)
};

/**
* | output |
* | --- |
* | "Docs saved" |
*
* @param {Wizard_Step_SavedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const wizard_step_saved = /** @type {((inputs?: Wizard_Step_SavedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wizard_Step_SavedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wizard_step_saved(inputs)
	return en_wizard_step_saved(inputs)
});